import { render, staticRenderFns } from "./CanteenManagers.vue?vue&type=template&id=75bc019b&"
import script from "./CanteenManagers.vue?vue&type=script&lang=js&"
export * from "./CanteenManagers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports